import { collective, projectMetas, projectStore, settings } from '@dabble/app';
import { createEditables } from '@dabble/data/editables';

export const editables = createEditables({ projectStore, projectMetas, settings, collective });
